module.exports = __webpack_public_path__ + "5c114213/img/note-edit-icon.acae1669.svg";